// 123 handle external links
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
	if (links[i].hostname !== window.location.hostname) {
		links[i].target = '_blank';
		links[i].relList.add('noreferrer', 'noopener');
	}
}

// jQuery
$(document).ready(function() {
  // CircleType
  $('.card__information .card__heading a').each(function(){
  	thisCircleType = $(this).attr('id');
  	circleType = new CircleType(document.getElementById(thisCircleType));
  	circleType.forceWidth(true);
  	circleType.forceHeight(true);
  	circleType.radius(140);
  })
  
  // Scroll on Hash
  if (window.location.hash) {
    var hash = window.location.hash;
    location.hash = ''; // empty hash so page loads at top everytime
    history.replaceState(null, null, ' '); // remove # from url

    if ($(hash).length) {
      $('html, body').delay(1000).animate({scrollTop: $(hash).offset().top - 84 },'slow', function(){
        $('.header li').removeClass('active');
        $('.header li a[href="'+hash+'"]').parent('li').addClass('active');
      });
    }
  }
  
  // Scroll on Nav
  if ( window.location.pathname == '/' ) { // homepage only
    $(".header__menu-item[href^='#'], .menu-drawer__menu-item[href^='#']").on('click', function(e){
      e.preventDefault();
      var clicked = $( this );
    
      $('.header li').removeClass('active');
      $(this).parent('li').addClass('active');
      
      var target = $(this).attr('href');
      location.hash = '';
      
      $('html,body').animate({scrollTop: ($(target).offset().top) - 84 },'slow');
      
      $('body').removeClass('overflow-hidden-tablet');
      $('.section-header').removeClass('menu-open');
      $('.menu-drawer-container').removeClass('menu-opening');
      $('.header__icon').attr('aria-expanded', 'false');
    });
  } else { // Replace # urls with /# urls so it works on inside pages
    $(".header__menu-item[href^='#'], .menu-drawer__menu-item[href^='#']").each(function(e){
      var target = $(this).attr('href'); // Get current url
      var newTarget = target.replace("#", "/#"); // Create new url
      $(this).attr("href", newTarget); // Set herf value
    });
  }
  
  // Force open Locations menu on mobile
  $("header-drawer .menu-drawer__menu details").attr('open', '');
})